import { useEffect } from 'react';
import { useSelector } from 'react-redux';

export const AccessLibreContainer = () => {

  const feature = useSelector(state => state.selectedFeature.feature);
  const layer_id = useSelector(state => state.selectedFeature.layer_id);
  const selected = useSelector(state => state.selectedFeature.selected);


  useEffect(() => {
    const widgetContainer = document.getElementById('widget-a11y-container');
    if (widgetContainer) {
      widgetContainer.remove();
    }
    const newContainer = document.createElement('div');
    newContainer.id = 'widget-a11y-container';
    const script = document.createElement('script');
    script.src = 'https://acceslibre.beta.gouv.fr/static/js/widget.js';
    script.type = 'text/javascript';
    script.async = true;
    if (selected && layer_id !== 'lignes_transports' && feature && Object.keys(feature).length > 0 && feature.properties.uuid) {
      newContainer.setAttribute('data-pk', feature.properties.uuid ?? '');
      newContainer.setAttribute('data-baseurl', 'https://acceslibre.beta.gouv.fr');
      document.body.appendChild(newContainer);
      document.body.appendChild(script);
    }

    return () => {
      if (newContainer && document.body.contains(newContainer)) {
        document.body.removeChild(newContainer);
      }
      if (script && document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };

  }, [feature]);

  return  null;
};